import {
  Card,
  Table,
  Button,
  Modal,
  Form,
  Select,
  message,
  Input,
  DatePicker,
  Tooltip,
  Row,
  Col,
  Checkbox,
} from "antd";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import { showAuthLoader, hideAuthLoader } from "../../appRedux/actions/Auth";
import Service from "../../service";
import moment from "moment";
import {
  EditOutlined,
  EyeOutlined,
  SaveTwoTone,
  CloseCircleTwoTone,
  ArrowLeftOutlined,
} from "@ant-design/icons";
import { getResource } from "../../util/getResourcePermission";
import config from "../../permission/config.json"
import * as XLSX from "xlsx";
import { capitalizeFirst, YearSelect } from "../../util/YearOptions";
import EmpNameCodeCell from "../common/EmpNameCodeCell";
import useBranchList from "../../hooks/useBranchList";
import useReportingManagerList from "../../hooks/useReportingManagerList";
import { Link } from "react-router-dom/cjs/react-router-dom";
import EditIcon from "../../assets/images/EditIcon";
import ViewIcon from "../../assets/images/ViewIcon";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import NodataFoundIcon from "../../assets/images/NodataFoundIcon";
import useCompanyDateFormat from "../../hooks/useCompanyDateFormat";
import { TABLE_PAGINATION, DEFAULT_PAGE_SIZE } from "../../constants/tablePagination";

function LWDResign() {
  const dateFormat = useCompanyDateFormat();
  const companySlug = localStorage.getItem("companyDomain")
  const dispatch = useDispatch();
  const [filterForm] = Form.useForm();
  const {
    branchList,
  } = useBranchList();
  // Admin-only "Reporting Manager" filter - RM/ARM viewers are already scoped to
  // their own team by the list endpoint, so the filter is not offered to them.
  const { isAdmin, reportingManagerOptions } = useReportingManagerList();
  const branchOptions = branchList.map(branch => ({
    label: branch?.branch_name,
    value: branch?._id,
  }));
  let [flag, setFlag] = useState(false);
  let [editid, setEditid] = useState();
  const [seachEnabled, setSearchEnabled] = useState(false);
  const [searchText, setSearchText] = useState("");
  // Deep link (e.g. Payroll Checklist → ?month=October&year=2026) opens the list
  // already filtered to that month, using the list's own Month / Year filter.
  const [filterData, setFilterData] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const month = params.get("month");
    const year = params.get("year");
    return month && year ? { month, year } : [];
  });
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);

  const hasAppliedFilter = filterData && Object.keys(filterData).length > 0
    ? Object.values(filterData).some((v) => v !== undefined && v !== null && v !== "")
    : false;
  const [assets, setAssets] = useState([]);
  const [Employees, setEmployees] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
  });
  const [isColumnModalVisible, setIsColumnModalVisible] = useState(false);
  const [selectedColumns, setSelectedColumns] = useState([]);
  const [availableColumns] = useState([
    { key: "EMP_CODE", label: "Employee Code" },
    { key: "EMP_NAME", label: "Employee Name" },
    { key: "LAST_DATE", label: "Last Date" },
    { key: "REPORTING_MANAGER", label: "Reporting Manager" },
    { key: "DEPARTMENT_NAME", label: "Department Name" },
    { key: "DESIGNATION", label: "Designation" },
  ]);

  // Set default selected columns on mount
  useEffect(() => {
    if (selectedColumns.length === 0) {
      setSelectedColumns(availableColumns.map(col => col.key));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Search = Input.Search;
  const searchRef = useRef();
  const [html, setHtml] = useState([]);
  const [selDate, setSelDate] = useState(null);

  const history = useHistory();
  const handleChangeDate = (date) => {
    setSelDate(date ? date.format('YYYY-MM-DD') : null);
  };

  const onSearch = (value) => {
    setSearchText(value);
    setPagination({ ...pagination, current: 1 });
  };
  const showfilterModal = () => {
    filterForm.setFieldsValue(hasAppliedFilter ? filterData : {});
    setIsModalOpenFilter(true);
  };
  const handleCancelFilter = () => {
    setIsModalOpenFilter(false);
  };

  const onModalReset = () => {
    filterForm.resetFields();
  };
  const handleEdit = async (empId) => {
    try {
      let reqBody = {
        last_date: selDate,
        resignationStatus: "Accepted",
      };

      dispatch(showAuthLoader());
      const response = await Service.makeAPICall({
        methodName: Service.putMethod,
        api_url: Service.editresign + "/" + empId,
        body: reqBody,
      });
      dispatch(hideAuthLoader());
      if (response.data && response.data.data) {
        message.success(response.data.message);
        getEmployeesResignList();
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resetSearchFilter = (e) => {
    const keyCode = e && e.keyCode ? e.keyCode : e;
    switch (keyCode) {
      case 8:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      case 46:
        if (searchRef.current.state?.value?.length <= 1 && seachEnabled) {
          searchRef.current.state.value = "";
          setSearchText("");
          setSearchEnabled(false);
        }
        break;
      default:
        break;
    }
  };
  useEffect(() => {
    // Keep the applied filter when paging / searching (it used to be dropped).
    getEmployeesResignList(filterData);
    getcsvData(filterData);
  }, [pagination.current, pagination.pageSize, searchText]);

  const getEmployeesResignList = async (filterData) => {
    try {
      dispatch(showAuthLoader());
      const reqBody = {
        pageNum: pagination.current,
        pageLimit: pagination.pageSize,
      };
      if (searchText && searchText !== "") {
        reqBody.search = searchText;
        setSearchEnabled(true);
      }
      if (filterData) {
        if (filterData?.month) {
          reqBody.month = filterData.month;
        }
        if (filterData?.year) {
          reqBody.year = filterData.year;
        }
        if (filterData?.branch) {
          reqBody.branch = filterData.branch;
        }
        if (
          filterData?.filter_reporting_manager &&
          filterData.filter_reporting_manager !== "Select"
        ) {
          reqBody.filter_reporting_manager_id =
            filterData.filter_reporting_manager;
        }
      }
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.last_working,
        body: reqBody,
      });

      dispatch(hideAuthLoader());
      if (response?.data?.data?.length > 0) {
        if (filterData?.isActive == true) {
          setPagination({
            ...pagination,
            total: response.data.metaData.totalFilteredCount,
            deactivetotal: response.data.metaData.totaldUsers,
          });
        } else {
          setPagination({
            ...pagination,
            total: response.data.metaData.totalFilteredCount,
          });
        }
        const filteredData = response.data.data.filter(
          (record) => record.resignationStatus === "Accepted"
        );
        setEmployees(filteredData);
        setEmployees(response.data.data);
      } else {
        setPagination({
          ...pagination,
          total: 0,
        });
        setEmployees([]);
      }
    } catch (error) {
      dispatch(hideAuthLoader());
      console.log(error);
    }
  };
  const getcsvData = async (filterData, showLoader = false) => {
    try {
      if (showLoader) {
        dispatch(showAuthLoader());
      }
      const reqBody = {
        isExport: true,
      };
      if (searchText && searchText !== "") {
        reqBody.search = searchText;
        setSearchEnabled(true);
      }

      // Add selected columns
      if (selectedColumns && selectedColumns.length > 0) {
        reqBody.selected_columns = selectedColumns;
      }

      if (filterData) {
        if (filterData?.month) {
          reqBody.month = filterData.month;
        }
        if (filterData?.year) {
          reqBody.year = filterData.year;
        }
        if (filterData?.branch) {
          reqBody.branch = filterData.branch;
        }
        if (filterData?.resignationStatus) {
          reqBody.resignationStatus = filterData.resignationStatus;
        }
        if (
          filterData?.filter_reporting_manager &&
          filterData.filter_reporting_manager !== "Select"
        ) {
          reqBody.filter_reporting_manager_id =
            filterData.filter_reporting_manager;
        }
      }
      const response = await Service.makeAPICall({
        methodName: Service.postMethod,
        api_url: Service.last_working,
        body: reqBody,
      });

      if (showLoader) {
        dispatch(hideAuthLoader());
      }

      if (response?.data?.html) setHtml(response?.data?.html);

    } catch (error) {
      if (showLoader) {
        dispatch(hideAuthLoader());
      }
      console.log(error);
    }
  };
  const columns = [
    {
      title: "Employee Name",
      dataIndex: "employee_name",
      key: "createdBy",
      render: (text, record) => <EmpNameCodeCell name={record?.createdBy} code={record?.emp_code} />,
    },
    {
      title: "Reporting Manager",
      dataIndex: "reporting_mgr",
      key: "reporting_mgr",
      render: (text, record, index) => {
        return <span>{capitalizeFirst(record?.reporting_mgr)}</span>;
      },
    },
    {
      title: "Last Date",
      dataIndex: "last_date",
      key: "last_date",
      render: (text, record, index) => {
        // Parse from the raw last_date, not a pre-formatted string - moment cannot parse
        // a "DD-MM-YYYY" string (or "-") without a format, which is what produced the
        // "Invalid date" / NaN calendar in the picker.
        const lastDateMoment = record?.last_date ? moment(record.last_date) : null;
        const hasValidDate = lastDateMoment && lastDateMoment.isValid();
        const position = hasValidDate ? lastDateMoment.format(dateFormat) : "-";
        return record?._id == editid ? (
          // Stop propagation so interacting with the picker doesn't bubble to the row
          // onClick, which otherwise opens the "Assets Allocated" view modal.
          <span
            style={{ textTransform: "capitalize" }}
            onClick={(e) => e.stopPropagation()}
            onMouseDown={(e) => e.stopPropagation()}
          >
            <DatePicker
              defaultValue={hasValidDate ? lastDateMoment : undefined}
              format="DD-MM-YYYY"
              onChange={handleChangeDate}
            />
          </span>
        ) : (
          <span style={{ textTransform: "capitalize" }}>{position}</span>
        );
      },
    },
    {
      title: "Department Name",
      dataIndex: "department_name",
      key: "department_name",
      render: (text, record, index) => {
        return <span>{capitalizeFirst(record?.department_name)}</span>;
      },
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      render: (text, record, index) => {
        return <span>{capitalizeFirst(record?.designation)}</span>;
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      className: "actions-column",
      fixed: "right",
      render: (text, record, index) => (
        <div
          style={{
            display: "flex",
            flexwrap: "wrap",
          }}
        >
          {flag == true && editid == record?._id ? (
            <>
              <Tooltip title="Save" placement="bottom">
                <Button
                  type="link edit"
                  onClick={(event) => {
                    event.stopPropagation();
                    handleEdit(record?._id);
                    setFlag(false);
                    setEditid("");
                  }}
                >
                  <SaveTwoTone />
                </Button>
              </Tooltip>
              <Tooltip title="Cancel" placement="bottom">
                <Button
                  type="link delete"
                  title="View"
                  onClick={(event) => {
                    event.stopPropagation();
                    setEditid("");
                  }}
                >
                  <CloseCircleTwoTone />
                </Button>
              </Tooltip>
            </>
          ) : (
            <>
              {getResource(config.RESOURCES.LAST_WORKING_DAY_LIST, ["update"]) && (
                <Tooltip title="Edit Last Date" placement="bottom">
                  <Button
                    type="link success"
                    onClick={(event) => {
                      event.stopPropagation();
                      setEditid(record._id);
                      setFlag(true);
                    }}
                  >
                    <EditIcon />
                  </Button>
                </Tooltip>
              )}
            </>
          )}
        </div>
      ),
    },
  ];

  const showModal = (record) => {
    setIsModalOpen(true);
    setAssets(record);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
    setAssets([]);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const getFooterDetails = () => {
    return (
      <label>
        Total Records Count is {pagination.total > 0 ? pagination.total : 0}
      </label>
    );
  };
  const handleTableChange = (page, filters, sorter) => {
    setPagination({ ...pagination, ...page });
  };
  const filterEmp = async (values) => {
    setFilterData(values);
    setIsModalOpenFilter(false);
    getEmployeesResignList(values);
    getcsvData(values);
  };

  const handleFilterChange = (allValues) => {
    const filterValues = { ...allValues };
    setFilterData(filterValues);
    setPagination({ ...pagination, current: 1 });
    getEmployeesResignList(filterValues);
    getcsvData(filterValues);
  };

  const downloadCSV = async () => {
    if (Employees.length === 0) {
      message.warning("No data to export");
      return;
    }

    // Close modal and trigger export
    setIsColumnModalVisible(false);
    dispatch(showAuthLoader());
    
    // Get CSV data with selected columns
    await getcsvData(filterData, false);
    
    // Wait for HTML to be set, then trigger download
    setTimeout(() => {
      const table = document.getElementById("table-to-xls");
      if (table) {
        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.table_to_sheet(table, { raw: true });
        XLSX.utils.book_append_sheet(wb, ws, "tablexls");
        XLSX.writeFile(wb, "Separation.xlsx");
      }
      dispatch(hideAuthLoader());
    }, 500);
  };

  return (
    <div>

      <Modal
        footer={false}
        title="Assets Allocated to this Employee"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        {assets.length > 0 ? assets.map((asset, index) => (
          <p key={index}>
            {index + 1}. {asset}
          </p>
        )) : <p>No assets allocated to this employee.</p>}
      </Modal>
      <Card className="employee-card">

        <div
          className="inout-header text-left"
        >
          <h2>Last Working Day Employees List</h2>

          <div className="header-btns">
            {/* <Link to={ `/${companySlug}/resignation-employee-list` }> */}
            <Button type="primary" onClick={() => history.goBack()} className="add-btn" icon={<ArrowLeftOutlined />}>Back</Button>
            {/* </Link> */}
          </div>
        </div>
        <Card className="main-content-wrapper" >

          <div className="steps-content">
            <div className="search-wrapper">
              <Search
                ref={searchRef}
                placeholder="Search..."
                onSearch={onSearch}
                onKeyUp={resetSearchFilter}
                style={{ width: 200 }}
                className="mr2  "
              />
              <div className="filter-btns-wrapper">
                <Button
                  type="primary"
                  onClick={showfilterModal}
                  className="filter-btn"
                >
                  Filter
                </Button>
                <Button
                  onClick={() => {
                    filterForm.resetFields();
                    setFilterData([]);
                    getEmployeesResignList();
                    getcsvData();
                  }}
                  className="mr2 ant-delete"
                  disabled={!hasAppliedFilter}
                >
                  Reset
                </Button>
                {getResource(config.RESOURCES.SEPARATION_MANAGEMENT, ["read"]) ? (<>
                  <Button
                    className=" btn-secondary "
                    disabled={Employees.length == 0}
                    onClick={() => {
                      setIsColumnModalVisible(true);
                    }}
                  >
                    Export CSV
                  </Button>

                  <div hidden>
                    <div dangerouslySetInnerHTML={{ __html: html["html"] }}></div>
                  </div>
                </>) : <></>}
              </div>
            </div>
            <div className='main-table-wrapper'>

              <Table
                locale={ { emptyText: <NodataFoundIcon/> } }
                columns={columns}
                dataSource={Employees}
                footer={getFooterDetails}
                onChange={handleTableChange}
                pagination={{
                  ...TABLE_PAGINATION,
                  ...pagination,
                }}
                onRow={(record) => {
                  return {
                    onClick: (event) => {
                      const isActionColumn = event.target.closest('.ant-table-cell')?.classList.contains('actions-column');
                      if (!isActionColumn) {
                        showModal(record?.assets);
                      }
                    },
                    style: {
                      cursor: 'pointer'
                    }
                  };
                }}
              ></Table>

            </div>
          </div>
        </Card>
      </Card>

      <Modal
        title="Filter"
        width={600}
        open={isModalOpenFilter}
        onCancel={handleCancelFilter}
        footer={[
          <Button key="cancel" className="ant-delete" onClick={handleCancelFilter}>
            Cancel
          </Button>,
          <Button key="reset" className="ant-delete" onClick={onModalReset}>
            Reset
          </Button>,
          <Button key="apply" type="primary" onClick={() => filterForm.submit()}>
            Apply
          </Button>,
        ]}

      >
        <Form
          form={filterForm}
          onFinish={filterEmp}
          layout="vertical"
          className="modal-form-col"
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} md={12}>


              <Form.Item label="Branch" name="branch">
                <Select
                  defaultValue="Select"
                  options={branchOptions}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>

              <Form.Item label="Month" name="month">
                <Select
                  defaultValue="Select"
                  options={[
                    { value: "January", label: "January" },
                    { value: "February", label: "February" },
                    { value: "March", label: "March" },
                    { value: "April", label: "April" },
                    { value: "May", label: "May" },
                    { value: "June", label: "June" },
                    { value: "July", label: "July" },
                    { value: "August", label: "August" },
                    { value: "September", label: "September" },
                    { value: "October", label: "October" },
                    { value: "November", label: "November" },
                    { value: "December", label: "December" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>


              <Form.Item label="Year" name="year">
                <Select
                  defaultValue="Select"
                  options={YearSelect()}
                />
              </Form.Item>
            </Col>
            {isAdmin && (
              <Col xs={24} md={12}>
                <Form.Item
                  label="Reporting Manager"
                  name="filter_reporting_manager"
                  initialValue="Select"
                >
                  <Select
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    options={reportingManagerOptions}
                  />
                </Form.Item>
              </Col>
            )}
          </Row>

        </Form>
      </Modal>

      <Modal
        title="Select Columns for Last Working Day Export"
        open={isColumnModalVisible}
        onCancel={() => setIsColumnModalVisible(false)}
        onOk={() => {
          if (selectedColumns.length === 0) {
            message.error("Please select at least one column");
            return;
          }
          downloadCSV();
        }}
        okText="Export CSV"
        cancelText="Cancel"
        width={700}
      >
        <div style={{ marginBottom: 16 }}>
          <Checkbox
            checked={
              availableColumns.length > 0 &&
              selectedColumns.length > 0 &&
              selectedColumns.length === availableColumns.length
            }
            indeterminate={
              selectedColumns.length > 0 &&
              selectedColumns.length < availableColumns.length
            }
            onChange={(e) => {
              if (e.target.checked) {
                setSelectedColumns(availableColumns.map((col) => col.key));
              } else {
                setSelectedColumns([]);
              }
            }}
          >
            Select All
          </Checkbox>
        </div>
        <Checkbox.Group
          value={selectedColumns}
          onChange={(values) => setSelectedColumns(values)}
          style={{ width: "100%" }}
        >
          <Row gutter={[16, 8]}>
            {availableColumns.map((column) => (
              <Col xs={12} sm={8} md={6} key={column.key}>
                <Checkbox value={column.key}>{column.label}</Checkbox>
              </Col>
            ))}
          </Row>
        </Checkbox.Group>
      </Modal>
    </div>
  );
}

export default LWDResign;
